<template>
  <div class="table-section">
    <div class="table-grid">
      <div class="grid-title-container">
        <div class="grid-title">
          <h2 class="c-white pl-10">{{ title }}</h2>
        </div>
      </div>
      
      <div class="grid-container">
        <div :scroll-x="true" class="option-row" nowrap>
          <div class="grid-header grid-items-container">
            <div class="grid-item" v-for="(header, headerIndex) in headers" :key="headerIndex"> {{ header }}</div>
          </div>
          <div class="grid-items grid-items-container" v-for="(row, index) in rows" :key="index">
            <div class="grid-item" :ref="`row${index}col${itemIndex}`" :style="styleEvenRows(index, itemIndex, row.length)" v-for="(item, itemIndex) in row" :key="itemIndex">
              <div class="grid-item-text">
                {{ getVal(item, row, itemIndex) }}
              </div>
            </div>
            <!-- <div class="`grid-item`" v-for="(item, itemIndex) in row" :key="itemIndex"> <span>{{ getVal(item, row, itemIndex) }}</span></div> -->
          </div>
          <!-- <div :style="{background: index % 2 == 0 ? '' : 'black', ...styleGridTemplateColumns(`4rem 4rem 4rem`, row.length)}" class="grid-items" v-for="(row, index) in rows" :key="index">
            <div class="grid-item" v-for="(item, itemIndex) in row" :key="itemIndex"> {{ getVal(item, row, itemIndex) }}</div>
          </div> -->
        </div>
      </div>
      
    </div>
  </div>
  
</template>

<script>
import _ from 'lodash';

export default {
  name: "TableGridMobile",
  props: ['title', 'headers', 'rows'],
  data() {
    return {
      nationalId : +process.env.VUE_APP_NATIONAL_ID,
      searchText: '',
      refElements: '',
      gridColumnWidthArray: [],
    }
  },
  mounted() {
    _.forEach(this.headers, (r, index) => {
      this.gridColumnWidthArray.push(0);
    });
    // setTimeout(() => {
      
    //   _.forEach(this.headers, (r, index) => {
    //     const refs = this.$refs;
    //     const griditem = refs[`griditem${index}`];
    //     console.log({
    //       griditem,
    //       column: index
    //     });
    //     _.forEach(griditem, (gi) => {
    //       const element = gi;
    //       console.log({
    //         element,
    //         width: element.offsetWidth,
    //         height: element.offsetHeight,
    //       });
    //       if (element.offsetWidth > this.gridColumnWidthArray[index]) {
    //         this.gridColumnWidthArray[index] = element.offsetWidth;
    //         // this.gridColumnWidthArray = 'Nice';
    //       }
    //     });
    //   });

    //   console.log({
    //     gridColumnWidthArray: this.gridColumnWidthArray
    //   });

    //   _.forEach(this.headers, (r, index) => {
    //     const refs = this.$refs;
    //     const griditem = refs[`griditem${index}`];
    //     console.log({
    //       griditem,
    //       column: index
    //     });
    //     _.forEach(griditem, (gi) => {
    //       const element = gi;
    //       console.log({
    //         element,
    //         width: element.offsetWidth,
    //         height: element.offsetHeight,
    //       });
    //       element.offsetWidth = this.gridColumnWidthArray[index];
    //     });
    //   });

    //   _.forEach(this.headers, (r, index) => {
    //     const refs = this.$refs;
    //     const griditem = refs[`griditem${index}`];
    //     console.log({
    //       griditem,
    //       column: index
    //     });
    //     _.forEach(griditem, (gi) => {
    //       const element = gi;
    //       console.log({
    //         element,
    //         width: element.offsetWidth,
    //         height: element.offsetHeight,
    //       });
    //     });
    //   });
      
    // }, 100);

    
    
    // Create a new MutationObserver
    // const observer = new MutationObserver(() => {
    //   // The button's text has changed
    //   console.log('Griditem text has changed!')
    // })
    // this.$nextTick(() => {
    //   const elements = this.$refs;
    //   this.refElements = _.map(this.rows, (r, index) => {
    //     const element = this.$refs[`row${index}col0`];
    //     return {
    //       element,
    //       elementItself: element[0],
    //       width: element[0].offsetWidth,
    //       height: element[0].offsetHeight,
    //     }
    //   });
    //   console.log({
    //     elements,
    //     refElements: this.refElements
    //   });
    // });

    // this.$watch(
    //   () => {
    //     return this.$refs;
    //   },
    //   (griditem) => {
    //     console.log(griditem);
    //   }
    // );
  },
  methods: {
    styleEvenRows(index, columnIndex, columnLength) {
      const style = {}
      if (index % 2 == 0) style.background = 'black';
      if (columnIndex === 0) {
        style.borderTopLeftRadius = '1rem' ;
        style.borderBottomLeftRadius = '1rem' ;
      }
      if (columnIndex === columnLength - 1) {
        style.borderTopRightRadius = '1rem' ;
        style.borderBottomRightRadius = '1rem' ;
      }
      style.wordBreak = 'break-word'
      // style.gridTemplateColumns = `repeat(${columnLength}, minmax(5rem, 1fr))`
      // console.log({
      //   style
      // });
      return style;
    },
    styleGridTemplateColumns(numColumns) {
      // const style = {gridTemplateColumns: `repeat(${numColumns}, 5rem)`};
      const style = {gridTemplateColumns: `repeat(auto-fit, minmax(5rem, 1fr))`};
      return style;
    },
    getVal(item, row, itemIndex) {
      if (this.nationalId === 8) {
        // Goal + Penalty Goal
        return itemIndex === 2 ? row[itemIndex] + row[itemIndex + 1] : item;
      }
      return item;
    }
  },
  watch: {
    // refElements: {
    //   handler(value) {
    //     console.log({
    //       value
    //     });
    //   }
    // },
    // rows: {
    //   handler(rowvalue) {
    //     console.log({
    //       rowvalue
    //     });
    //   }
    // },
    // gridColumnWidthArray: {
    //   handler(gridColumnWidthArrayValue) {
    //     console.log({
    //       gridColumnWidthArrayValue
    //     });
    //   }
    // },
  }
};
</script>

<style scoped>
.table-section {
  display: flex;
  justify-content: center;
  width: 100%;
}
.table-grid {
  background: #1d1f22;
  /* padding: 1rem 1.5rem; */
  border-radius: 14px;
  width: 90%;
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: 400;
  font-size: .7rem;
  /* line-height: 1rem; */
  /* text-align: center; */
  color: #fff;
  /* grid-template-columns: ; */
  padding-bottom: 2rem;
}
.grid-title-container{
  width: 100%;
  display: flex;
  justify-content: center;
}

.grid-title {
  padding: 1rem;
  width: 90%;
}

.option-row {
  --offset-bottom: auto!important;
  --overflow: hidden;
  overflow: auto;
  /* max-width: 70%; */
  border-radius: 1rem;
  padding: 0;
  margin: 0;
  background: #1e1f22 !important;
  background-color:burlywood;
  width: 95%;
}

.grid-container {
  display: flex;
  justify-content: center;
  /* background-color: aqua; */
}
.grid-header {
  /* display: grid; */
  display: flex;
  /* gap: 0.5rem; */
  /* grid-template-columns: 4rem 8rem 4rem repeat(auto-fill, 4rem); */
  /* padding: 0.5rem 1.5rem; */
  margin-bottom: 1.5rem;
  color: #a9a9a9;
  font-size: 0.8rem;
  font-weight: bold;
  text-overflow: clip;
  white-space: nowrap;
}

.grid-items {
  /* display: grid; */
  display: flex;
  /* gap: 0.5rem; */
  /* grid-template-columns: 4rem 8rem 4rem repeat(auto-fill, 4rem); */
  background: #1d1f22;
  /* padding: 1rem 1.5rem; */
  /* width: 100%; */
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: 400;
  font-size: .7rem;
  line-height: 1rem;
  color: #fff;
  text-overflow: clip;
  white-space: nowrap;
  width: auto;
  border-radius: 1rem;
  height: 3rem;
}

.grid-items-container {
  width: 100%;
}

.grid-item {
  display: flex;
  justify-content: center;
  align-items: center;
  /* width: 5rem; */
  width: 100%;
  min-width: 5rem;
  /* min-width: 40%; */
}

.grid-item-text {
  word-break: break-word;
  overflow: hidden;
  /* overflow-wrap: break-word; */
  min-width: 0;
}
</style>
